import { index } from "d3";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory,useLocation } from "react-router-dom";
import {
  setSelectedClient,
  fetchClientTagData,
  fetchCustomClientDetails,
  getClientMasterUserData,
  getClientSubUserData,
  getState,
  getClientLanguages,
} from "../../actions/client-action";
import { fetchEntityDetails, getData } from "../../actions/entity-action";
import { COOKIE, TRACKING_ALLOWED_CLIENTS } from "../../constants/app-constant";
import { DASHBOARD_CONTAINER } from "../../constants/route-constants";
import { getCookie, setCookie } from "../../utility/cookieProvider";
import { OrgArrowIcon } from "../Icons/icons.component";
import Initials from "../Shared/Initials";
import { isArticleRoute } from "../../utility/common-methods";
const ClientList = () => {
  const location = useLocation();
  const clientsToUser =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.clientsToUser
    ) || [];
  const journalistAccess =
    useSelector(
      (state) => state.clientReducer.allowJournalistAccess
    ) ;
  const selectedClient =
      useSelector(
        (state) => state.clientReducer && state.clientReducer.selectedClient
      ) || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [setClient, setSetClient] = useState();
  const [showList, setShowList] = useState(false);
  const [initialClient, setInitalClient] = useState("");
  const clientId = getCookie(COOKIE.CONCEPT_CLIENT_ID);
  let allowedRoute = isArticleRoute(location.pathname);

  useEffect(() => {
    setSetClient(clientsToUser[0]);
    if(Array.isArray(clientsToUser) && clientsToUser.length === 1){
      setCookie({
        key: COOKIE.CONCEPT_CLIENT_ID,
        value: clientsToUser[0].id,
      });
    }
  }, [clientsToUser]);

  useEffect(() => {
    if(typeof journalistAccess == "undefined" && Object.keys(selectedClient).length && allowedRoute){
      dispatch(fetchCustomClientDetails(selectedClient.id,selectedClient.client_name))
    }
  },[journalistAccess,selectedClient])


  // useEffect(() => {
  //   if (clientId) {
  //     const client = clientsToUser.filter((client) => {
  //       if (client.id === clientId) {
  //         return client;
  //       }
  //       return null;
  //     })[0];
  //     const index = clientsToUser.indexOf(client);
  //     setSetClient(clientsToUser[index]);
  //     if (client && client.id) {
  //       dispatch(fetchClientTagData(client.id));
  //       dispatch(setSelectedClient(client));
  //       dispatch(fetchEntityDetails(client.id));
  //     }
  //   } else {
  //     setSetClient(clientsToUser[0]);
  //   }
  //   setSetClient(clientsToUser[0]);
  // }, [clientsToUser]);

  const handleClientChange = (id) => {
    setCookie({
      key: COOKIE.CONCEPT_CLIENT_ID,
      value: id,
    });
    setShowList(!showList);
    if (id) {
      const client = clientsToUser.filter((client) => {
        if (client.id === id) {
          return client;
        }
        return null;
      })[0];
      setSetClient(client);
      if (client && client.id) {
        dispatch(getData(client.id));
        if(TRACKING_ALLOWED_CLIENTS.includes(client.id.toString())){
          dispatch(getClientMasterUserData(client.id,getCookie(COOKIE.CONCEPT_USER_ID)));
          dispatch(getClientSubUserData({client_id:client.id}));
          dispatch(getClientLanguages(client.id));
          dispatch(getState());
        }
        dispatch(fetchClientTagData(client.id));
        dispatch(setSelectedClient(client));
        dispatch(fetchEntityDetails(client.id, client.client_name));
        history.push(DASHBOARD_CONTAINER);
      }
    }
  };

  const isSingleClient =
  Array.isArray(clientsToUser) && clientsToUser.length === 1;

  if (isSingleClient) {
    return (
      <div className="orgName singleOrg">
        {/* {clientsToUser[0].client_logo &&
        clientsToUser[0].hide_client_logo == "0" ? (
          <span className="orgImageWrap">
            <img
              src={clientsToUser[0].client_logo}
              alt={clientsToUser[0].client_name}
              className="orgImage"
            />
          </span>
        ) : ( */}
        <>
          <span className="orgName">{clientsToUser[0].client_name}</span>
        </>
      </div>
    );
  }

  return (
    <div className="menuTitle">
      <div className="orgName">{setClient ? setClient.client_name : ""}</div>
      <div className="switchOrgDropdown">
        <span onClick={() => setShowList(!showList)}>
          Switch Organisation <OrgArrowIcon />
        </span>
        <ul className={showList ? "" : "hide"}>
          {Array.isArray(clientsToUser) &&
            clientsToUser.map((client) => {
              if (!client) {
                return null;
              }
              return (
                <li
                  key={client.id}
                  onClick={(e) => handleClientChange(client.id)}
                >
                  <a href="#">
                    {/* {client.client_logo && client.hide_client_logo == "0" ? (
                      <span className="orgImageWrap">
                        <img
                          src={client.client_logo}
                          alt={client.client_name}
                          className="orgImage"
                        />
                      </span>
                    ) : ( */}
                    <span className="orgTitle">
                      <Initials name={client.client_name} />{" "}
                      {client.client_name}
                    </span>
                    {/* )} */}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default ClientList;
